import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  CircularProgress,
} from '@mui/material';
import { Search } from '@mui/icons-material';

const Tracking = () => {
  const [reference, setReference] = useState('');
  const [products, setProducts] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setProducts(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const response = await fetch(`${API_URL}/tracking.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ referenceColis: reference })
      });

      const data = await response.json();
      
      if (data.success) {
        setProducts(data.data);
        if (data.data.length === 0) {
          setError('Aucun produit trouvé pour cette référence');
        }
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Erreur lors de la recherche. Veuillez réessayer.');
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          py: 8,
          mb: 6,
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" gutterBottom>
            Suivi de Colis
          </Typography>
          <Typography variant="h5">
            Suivez l'état de votre expédition en temps réel
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md">
        <Paper sx={{ p: 4, mb: 4 }}>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <TextField
                fullWidth
                label="Référence du colis"
                variant="outlined"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                placeholder="Entrez votre numéro de suivi"
                sx={{ flex: 1 }}
                disabled={loading}
              />
              <Button
                type="submit"
                variant="contained"
                size="large"
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Search />}
                sx={{ height: 56 }}
                disabled={loading || !reference.trim()}
              >
                {loading ? 'Recherche...' : 'Rechercher'}
              </Button>
            </Box>
          </form>
        </Paper>

        {error && (
          <Alert severity="error" sx={{ mb: 4 }}>
            {error}
          </Alert>
        )}

        {products && products.length > 0 && (
          <TableContainer component={Paper} sx={{ mb: 4 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Référence</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Prix</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Conteneur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((product) => (
                  <TableRow key={product.referenceproduits}>
                    <TableCell>{product.referenceproduits}</TableCell>
                    <TableCell>{product.descriptionproduits}</TableCell>
                    <TableCell>{product.typesproduits}</TableCell>
                    <TableCell>{product.prixunitaire} €</TableCell>
                    <TableCell>{product.status_description || `Statut ${product.statut}`}</TableCell>
                    <TableCell>{product.conteneur || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Box>
  );
};

export default Tracking;
